import Image from 'next/image';
import React, { ReactElement } from 'react';
import { ASSET_URL } from 'lib/constants';
import CMSLink from './CMSLink';
import Button from './ui/button';
import Text from './ui/text';
import cn from 'classnames';

interface Props {
  feature: any;
}

export default function FeaturesItem({ feature }: Props): ReactElement {
  const [isHover, setIsHover] = React.useState(false);
  const includeLink = feature?.includeLink ?? false;
  const { link } = feature;
  return (
    <div
      onMouseEnter={includeLink ? () => setIsHover(true) : undefined}
      onMouseLeave={includeLink ? () => setIsHover(false) : undefined}
      className={cn(
        'col-span-4 group flex flex-col relative justify-start items-start border-t border-heading p-8 hover:border-telesoft transition-all duration-300',
        {
          'hover:bg-black': includeLink,
        }
      )}
    >
      <div className="flex flex-col justify-between h-full">
        <div className="flex flex-col justify-start items-start">
          <Text
            variant="heading"
            className={cn('tracking-wide mb-4 text-black', {
              'group-hover:text-white': includeLink,
            })}
          >
            {feature.title}
          </Text>
          <p
            className={cn('', {
              'group-hover:text-white': includeLink,
            })}
          >
            {feature.description}
          </p>
        </div>

        <div
          className={`w-12 h-12 md:w-16 md:h-16 xl:w-18 xl:h-18 relative mt-5 transition duration-200 ${
            isHover ? 'opacity-0' : 'opacity-100'
          }`}
        >
          <Image
            alt={feature.image.alt || ''}
            layout="fill"
            src={ASSET_URL + '/' + feature.image.filename}
          />
        </div>
      </div>

      {isHover && includeLink && (
        <CMSLink {...link}>
          <Button
            variant="cta"
            invert={true}
            className="absolute bottom-10 text-white"
          >
            {link?.label || 'Learn More'}
          </Button>
        </CMSLink>
      )}
    </div>
  );
}
